class ExternalFormsUtils {
  static applyStyles = () => {
    const iframe = document.querySelector(
      ".hs-form-iframe"
    ) as HTMLIFrameElement;
    if (!iframe) return;

    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow?.document;
    if (iframeDocument) {
      const styleElement = iframeDocument.createElement("style");
      styleElement.textContent = `
        .hs-form-iframe {
          height: 100% !important;
          display: flex;
          flex-wrap: wrap;
        }
        .hs-form {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }
        .hs-form > div {
          width: 100%;
        }
        .hs-form .hs-fieldtype-text {
          width: calc(50% - 10px);
          display: inline-block;
        }
        .hs-submit > .actions {
          text-align: center !important;
        }
        .hs-submit input {
          display: inline-block;
          padding: 10px 0 8px;
          border-color: #0981f0 !important;
          background-color: #0981f0 !important;
          color: #ffffff !important;
          text-decoration: none;
          border-radius: 50px;
          font-family: "GrotzecHdCnDemi" !important;
          font-size: 18px !important;
          font-weight: 500;
          line-height: 19px !important;
          text-align: center;
          text-underline-position: from-font;
          text-decoration-skip-ink: none;
          min-width: 215px;
          border: 1px solid #0981f0;
          cursor: pointer;
        }
      `;
      iframeDocument.head.appendChild(styleElement);
    }
  };

  static waitForIframeAndApplyStyles = () => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const iframe = document.querySelector(
        ".hs-form-iframe"
      ) as HTMLIFrameElement;
      if (iframe) {
        ExternalFormsUtils.applyStyles();
        clearInterval(interval);
      } else if (Date.now() - startTime > 10000) {
        clearInterval(interval);
      }
    }, 100);
  };
}

export default ExternalFormsUtils;
